import React from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox } from 'day8-ui';
import { TbAirConditioning } from "@react-icons/all-files/tb/TbAirConditioning";
import { getSelectedFilters, isFilterSelected, onFilterSelect } from '../../../../helpers/filter';
import { capitalizeFirstLetter } from '../../../../helpers/utilities';
import { FILTERS } from '../../../../constants';
import { useDispatch } from 'react-redux';

const Amenities = props => {
  const dispatch = useDispatch();
  const availableAmenities = ['Air Conditioning'];
  const selectedFilterText = getSelectedFilters(props.location)[FILTERS.AMENITIES].map(item => capitalizeFirstLetter(item)).join(', ');
  return props.mobile ? (
    <div className={props.className}>
      <div>
        <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Amenities</h3>
        <div className={props.inline ? 'dui-flex dui-flex-wrap dui-gap-4' : ''}>
          <Checkbox
            onClick={e => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.AMENITIES, e.target.value)}
            options={availableAmenities.map(amenity => ({
              label: capitalizeFirstLetter(amenity),
              value: amenity,
              checked: isFilterSelected(props.location, FILTERS.AMENITIES, amenity)
            }))}
          />
        </div>
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<TbAirConditioning />}>{selectedFilterText || 'Amenities'}</Button>;
};
Amenities.propTypes = {
  location: PropTypes.object.isRequired,
  filterAction: PropTypes.func.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.bool
};
export default Amenities;
